import React from 'react';
import './spinner.css';
import LogoMarkLoader from '../logo-mark-loader/LogoMarkLoader';

/**
 * Spinner Component
 *
 * Large and extra-large sizes use the June logo mark flip.
 * Small and medium stay a circle, for buttons and inline status.
 *
 * @param {Object} props
 * @param {string} props.size - Size of the spinner ('sm', 'md', 'lg', 'xl')
 * @param {string} props.color - Color of the circle spinner (default: 'primary-700')
 * @param {string} props.className - Additional CSS classes
 */
const Spinner = ({
    size = 'lg',
    color = 'primary-700',
    className = ''
}) => {
    if (size === 'lg' || size === 'xl') {
        return <LogoMarkLoader className={className} />;
    }

    const sizeClasses = {
        sm: 'h-4 w-4',
        md: 'h-6 w-6',
    };

    return (
        <div className={`flex items-center justify-center ${className}`}>
            <div className={`animate-spin rounded-full border-b-2 ${sizeClasses[size]} spinner-${color}`}></div>
        </div>
    );
};

export default Spinner;
